<script>
import { round } from 'lodash'
import { mapComputedFormFields, mapComputedStateFields } from '~/mixins/globalForm'

export default {
  name: 'AvgRespondTime',
  props: {
    itemId: {
      type: [Number, String],
      required: true
    },
    repo: {
      type: String,
      required: true,
      default: ''
    },
    idx: {
      type: Number,
      default: -1
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      state: false
    }
  },
  computed: {
    ...mapComputedFormFields('customerEdit', [
      'avg_user_response_in_minutes',
      'avg_user_response_by_admin'
    ]),
    ...mapComputedStateFields('customerEdit', [
      'info'
    ]),
    dirty () {
      const form = this.$store.state.forms.customerEdit && this.$store.state.forms.customerEdit.forms.find(i => i.id === this.itemId)
      return form && form.dirty
    },
    isDirty () {
      const dirtyFields = Object.keys(this.dirty)
      if (dirtyFields.length && dirtyFields.includes('avg_user_response_in_minutes')) {
        return true
      }
      return false
    },
    isByAdmin () {
      return this.avg_user_response_by_admin || false
    },
    selectedOption () {
      return this.options.find(i => i.value === this.avg_user_response_in_minutes || 0)
    },
    selectOptions () {
      return this.options.map((i) => {
        return {
          value: i.value,
          text: `${i.text}${i.desc !== '' ? ` (${i.desc})` : ''}`
        }
      })
    },
    responseTimeClass () {
      let $className = ''
      if (this.avg_user_response_in_minutes > 0 && this.avg_user_response_in_minutes <= (12 * 60)) {
        $className = 'text-dark-green'
      } else if (this.avg_user_response_in_minutes > (12 * 60) && this.avg_user_response_in_minutes <= (24 * 60)) {
        $className = 'text-light-blue'
      } else if (this.avg_user_response_in_minutes > (24 * 60)) {
        $className = 'text-red'
      }
      return $className
    },
    displayLabel () {
      if (typeof this.selectedOption !== 'undefined') {
        return this.selectedOption.text
      }
      return (
        this.info.profile &&
        this.info.profile.display_avg_user_response
      ) || 'none'
    },
    displayDesc () {
      if (typeof this.selectedOption !== 'undefined') {
        return this.selectedOption.desc
      }
      return (
        this.info.profile &&
        this.info.profile.display_avg_user_response_desc
      ) || ''
    },
    displayMinutes () {
      return round(this.avg_user_response_in_minutes, 0)
    }
  },
  watch: {
    avg_user_response_in_minutes (n, o) {
      if (n && n !== o) {
        this.$forceUpdate()
      }
    }
  },
  methods: {
    toggle () {
      this.state = !this.state
    },
    adminChanged () {
      this.avg_user_response_by_admin = true
      this.state = false
    },
    adminCancel () {
      this.avg_user_response_in_minutes = 0
      this.avg_user_response_by_admin = false
      this.state = false
    }
  }
}
</script>

<template>
  <div class="avg-response-time d-flex flex-column" :class="{'bg-warning': isDirty}">
    <div class="d-flex align-items-center justify-content-end flex-nowrap">
      <div class="mr-2 font-weight-bold">
        {{ $t('fCustomer_head_responseTime') }}:
      </div>
      <div
        :class="responseTimeClass"
        class="mr-2 nowrap"
      >
        <small>{{ displayLabel }}</small>
      </div>
      <b-link
        v-if="!state && !isLocked"
        @click="toggle"
      >
        <font-awesome-icon
          size="sm"
          class="ml-2 text-danger"
          :icon="['fas', 'pen']"
        />
      </b-link>
    </div>

    <div
      v-if="state && !isLocked"
      class="d-flex align-items-center justify-content-end"
    >
      <b-form-select
        v-model="avg_user_response_in_minutes"
        :options="selectOptions"
        size="sm"
        style="width: 220px"
        @input="adminChanged"
        @keydown.esc="toggle"
      />
      <small>
        <b-link @click="toggle">
          <font-awesome-icon
            size="sm"
            class="ml-2 text-danger"
            :icon="['fas', 'xmark']"
          />
        </b-link>
      </small>
    </div>
    <small v-if="isByAdmin" :class="responseTimeClass">
      {{ $t('fCustomer_head_by_admin') }}
      <b-link
        :title="$t('fCustomer_head_by_admin_delete')"
        @click="adminCancel"
      >
        <font-awesome-icon
          size="sm"
          class="ml-2 text-danger"
          :icon="['fas', 'trash']"
        />
      </b-link>
    </small>
    <small v-if="displayDesc !== ''" :class="responseTimeClass">{{ displayDesc.toLowerCase() }}</small>
    <small v-if="!isByAdmin && avg_user_response_in_minutes > 0" class="ml-2">
      {{ displayMinutes }} {{ $t('fCustomer_head_minutes') }}
    </small>
  </div>
</template>

<style scoped>
.text-dark-green {
  color: #0f6848;
}

.text-light-green {
  color: #3dc192;
}

.text-light-blue {
  color: #1ca0c8;
}

.text-orange {
  color: #fd7e14;
}

.text-red {
  color: #be2617;
}
</style>
